import sha256 from 'js-sha256';


const Hash = (input) => {

    var x = sha256(input);
    console.log(x);
    return x;
}

export default Hash;